<template>
  <IFrameContainer
  v-if="isFeatureEnabled !== null"
:dashboard="isFeatureEnabled ? 88: 6"
:project="isFeatureEnabled ? 'foodics':'skylineDynamics'"/>
</template>

<script>
import IFrameContainer from '../components/IFrameContainer.vue';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { Feature_Flags } from '@/enums/globals';

export default {
  name: 'ReportsCustomers',
  components: {
    IFrameContainer,
  },
  data () {
    return {
      isFeatureEnabled: null,
    };
  },
  mounted () {
    const { isFeatureEnabled } = useFeatureFlags();
    this.isFeatureEnabled = isFeatureEnabled(Feature_Flags.METABASE_FOODICS_WORKSPACE);
    // eslint-disable-next-line no-undef
    analytics.track('view_customers_report', {});
  },
};
</script>
